import * as fromRootMiscActions from './misc/misc.actions';
import * as fromRootSearchActions from './search/search.actions';
import * as fromRootImpeActions from './impersonate/impe.actions';
import * as fromRootFilterTagActions from './filter-tag/filter-tag.actions';

export
{
    IRootState,
    getRootVersionDeployed,
    getPopinFormDirtyStatus, getUploadFileDirtyStatus, getPopinFormWithUploadFileDirtyStatus,
    getExtraDataDirtyStatus, getPopinFormWithExtraDataDirtyStatus,
    getPopinOverStatus, getFilterStatus, getRootRangeViewerSinceUntil,

    getSearchValue,
    getIts2RequestsSearchQueryString, getIts2RequestsSearchResults,

    getBckpJobsSearchQueryString, getBckpJobsSearchResults,
    getBckpServersSearchQueryString, getBckpServersSearchResults,
    getBckpPoliciesSearchQueryString, getBckpPoliciesSearchResults,
    getCompInstancesSearchQueryString, getCompInstancesSearchResults,
    getBackAuthEntitiesSearchQueryString, getBackAuthEntitiesSearchResults,
    getBackAuthUsersSearchQueryString, getBackAuthUsersSearchResults,

    getRootImpersonation,

    getChipsStatus, getWarningsValue,

    getQuickSearchValue,

    getLastAdminUrl, getLastCustomerUrl
} from './root.reducer';

export
{
    getFilterTags
} from './filter-tag/filter-tag.selectors';

export { RootStoreModule } from './root-store.module';
export { selectUrl, selectRouteData, getRouteInfos } from './router/router.reducer';
export
{
    fromRootMiscActions as RootMiscStoreActions,
    fromRootSearchActions as RootSearchStoreActions,
    fromRootImpeActions as RootImpeStoreActions,
    fromRootFilterTagActions as RootFilterTagActions
};
